import { render, staticRenderFns } from "./BigImgByIncoming.vue?vue&type=template&id=2384bdff&scoped=true"
import script from "./BigImgByIncoming.vue?vue&type=script&lang=js"
export * from "./BigImgByIncoming.vue?vue&type=script&lang=js"
import style0 from "./BigImgByIncoming.vue?vue&type=style&index=0&id=2384bdff&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2384bdff",
  null
  
)

export default component.exports